
























import createStoreModule from './store';
import { mapActions } from 'vuex';
import { Component, Mixins, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Spaces } from './types';
import SpaceCard from './components/SpaceCard.vue';
import SelectCount from '@/components/parts/catalog/list/count';

import isArrayNotEmpty from '@/tools/isarraynotempty';
import { Context } from '@/types';
import { PAGE_SIZE, PAGE_SIZES, PAGE_NUMBER, BY_PAGE_TEXT } from './const';
import { Paginator } from '@/components/parts/pagination';
import PageListMixin from '@/pages/mixin-list';

const STORE_MODULE_NAME = 'spaces';
const actions = mapActions(STORE_MODULE_NAME, ['init']);
const fetch = actions['init'];
const SpacesStore = namespace(STORE_MODULE_NAME);
const getPageSize = (value?: string) => value || PAGE_SIZE;

@Component({
  name: "Space",
  storeName: STORE_MODULE_NAME,
  storeRegister: createStoreModule,
  components: {
    SpaceCard,
    Paginator,
    SelectCount
  }
})
export default class Space extends Mixins(
  PageListMixin
) {
  @SpacesStore.State spaces: Spaces;
  @SpacesStore.State count: number;
  @SpacesStore.State page: number;
  @SpacesStore.State limit: number;
  readonly pageSizes = PAGE_SIZES;
  readonly byPageText = BY_PAGE_TEXT;
  get pagesCount(): number {
    const { count, limit } = this;
    return limit ? Math.ceil(count / limit) : 0;
  }

  get pageLimit() {
    return getPageSize(this.$route.query.limit as any);
  }

  get pageLimits() {
    return this.pageSizes.map((value) => ({ value, text: value }));
  }

  get hasSpaces() {
    return isArrayNotEmpty(this.spaces);
  }

  get partnerId() {
    return this.$route.params.id;
  }

  asyncData({ store, route }: Context): Promise<any> {
    const context = { $store: store };
    const params = { partnerId: route.params.id };
    const query = { ...route.query };
    query.page = String(query.page || PAGE_NUMBER);
    query.limit = String(getPageSize(query.limit));
    return fetch.call(context, { params, query });
  }

}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/pages/organizations/card/spaces/Spaces.vue